import React from 'react';
import { Modal } from 'antd';
import type { TFunction } from 'i18next';

/**
 * 路线邮编编辑页的数据录入类校验失败（确认生效 / 导入预览等）：用常驻弹框展示后端原始报错
 * （如「邮编 X 属于多条路线」「Cannot remove zipcodes with in-transit orders: ...」），
 * 用户需点「关闭」才消失；内容可选中，便于手动框选复制邮编等信息。
 *
 * 之所以不用 message.error（toast 会自动消失、无法复制），是产品要求可确认后关闭 + 可复制。
 *
 * @param title 弹框标题；不传时默认「确认生效失败」，导入等场景可传各自标题（如「导入失败」）。
 */
export const showRouteChangeErrorModal = (content: string, t: TFunction, title?: string): void => {
  Modal.error({
    title: title ?? t('central.sites.messages.routeChangeConfirmFailed'),
    width: 520,
    okText: t('common.close'),
    content: (
      <div
        data-testid="route-change-error-content"
        style={{ whiteSpace: 'pre-wrap', userSelect: 'text', wordBreak: 'break-all' }}
      >
        {content}
      </div>
    ),
  });
};
